import { Injectable } from '@angular/core';
import { UrlParamsState } from '../../modules/url-params/url-params.state';
import { Store } from '@ngrx/store';
import { selectUrlParams } from '../../modules/url-params/url-params.selector';
import { ContainerComponent } from '../../modules/shared/components/container-component/unsubscribe.component';
import { SourceAppEnum } from '../model/source-app.enum';
import { UrlParams } from '../../modules/url-params/model/url-params.model';

/**
 * Used to detect the source of launching the selfservice. Usually, there is a link from another app to this app,
 * this service detects which app was the origin.
 */

@Injectable()
export class SourceAppService extends ContainerComponent {
    public sourceApp: SourceAppEnum = SourceAppEnum.UNKNOWN;
    private oidc: boolean;

    constructor(private store: Store<UrlParamsState>) {
        super();
        this.store.select(selectUrlParams)
            .filter((params: UrlParams) => !!params && !!params.access_token)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((params: UrlParams) => {
                this.oidc = params.oidc;
                if (!!params.channelId) {
                    this.sourceApp = SourceAppEnum.S24;
                } else if (!!params.cluid) {
                    if (sessionStorage.getItem('roleSspAutenticationUsersRW') === 'true') {
                        this.sourceApp = SourceAppEnum.CPS_RW;
                    } else {
                        this.sourceApp = SourceAppEnum.CPS;
                    }
                } else if (!!params.state) {
                    this.sourceApp = SourceAppEnum.GEORGE;
                } else {
                    this.sourceApp = SourceAppEnum.UNKNOWN;
                }
            });
    }

    public isFromServis(): boolean {
        return this.sourceApp === SourceAppEnum.S24;
    }

    public isFromGeorge(): boolean {
        return this.sourceApp === SourceAppEnum.GEORGE;
    }

    public isFromCps(): boolean {
        return this.sourceApp === SourceAppEnum.CPS || this.sourceApp === SourceAppEnum.CPS_RW;
    }

    public isFromCpsRW(): boolean {
        return this.sourceApp === SourceAppEnum.CPS_RW;
    }

    public isOidc(): boolean {
        return this.oidc;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/services/source-app.service.ts